import _ from 'lodash';
import { DEVICE_FLAGS } from '../../constants/deviceFlags';
import { DEFAULT_LANGUAGE, LANGUAGE } from '../../constants/lang';
import { AUTH_LOGIN, AUTH_UPDATE_USER, LANG_MANAGER_UPDATE_REPO } from '../actions';
import { setLang, updateLang } from '../actions/lang.actions';
import { getDeviceFlag } from '../selectors/device-flag.selector';

// Bundled lang is the baseline, remote config overrides per key — so a lagging
// remote repo can't blank out new keys. Merged into the repo itself so that
// setLang (reading langManager.repo on login/user updates) sees it too.
const mergeRepoOverBundled = (repo = {}) => {
  const localeKeys = new Set([...Object.keys(LANGUAGE), ...Object.keys(repo)]);
  return Object.fromEntries(
    [...localeKeys].map(localeKey => {
      const local = LANGUAGE[localeKey];
      const remote = repo[localeKey];
      if (!local || !remote) return [localeKey, local || remote];
      return [localeKey, { ...local, ...remote, lang: _.merge({}, local.lang, remote.lang) }];
    }),
  );
};

export const langUpdateOnRepoUpdate =
  ({ dispatch, getState }) =>
  next =>
  async action => {
    if (action.type !== LANG_MANAGER_UPDATE_REPO) {
      return next(action);
    }

    const repo = mergeRepoOverBundled(action.payload.repo);
    next({ ...action, payload: { ...action.payload, repo } });

    const FLAG = DEVICE_FLAGS.LANGUAGE;
    const { deviceFlags, auth } = getState();
    let languageKey =
      auth.user?.language || getDeviceFlag(deviceFlags, { key: FLAG }) || DEFAULT_LANGUAGE;

    const { lang } = repo[languageKey.toLowerCase()] || repo[DEFAULT_LANGUAGE];

    dispatch(updateLang({ lang }));
  };

export const langUpdateOnUserUpdate =
  ({ dispatch }) =>
  next =>
  async action => {
    next(action);

    if (action.type === AUTH_UPDATE_USER || action.type === AUTH_LOGIN) {
      if (!action.payload?.user?.language) {
        return;
      }

      dispatch(setLang({ key: action.payload.user.language }));
    }
  };

export const langMiddleware = [langUpdateOnRepoUpdate, langUpdateOnUserUpdate];
